import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable()
export class UserSettingService {
    constructor (public http: HttpClient, private _authService: AuthService) {}

    private get _defaultOptions() { return { headers: this._headers }; }
    private get _headers(): HttpHeaders {
        let h = new HttpHeaders();
        h = h.set('Authorization', `bearer ${this._authService.accessToken}`);
        h = h.set('Content-Type', 'application/json');
        return h;
    }

    async get(key: string): Promise<any> {
        let options: object = {headers: this._headers, responseType: 'text'};
        let result = await this.http.get(`${environment.api}/api/v1/user-settings?key=${key}`, options)
            .toPromise()
            .then((res: any) => { return JSON.parse(res) });
        return result;
    }

    async set(key: string, value: any) {
        let json = JSON.stringify(value);
        await this.http.put(`${environment.api}/api/v1/user-settings`, { key: key, value: json } , this._defaultOptions)
            .toPromise();
    }

    async delete(key: string) {
        await this.http.delete(`${environment.api}/api/v1/user-settings?key=${key}`, this._defaultOptions)
            .toPromise();
    }
}
